import { LANGUAGES } from '../../constants';
import { StyleLayout } from '../components/layout';
import type { StyleProps } from './types';

export function Style1({ items, onClick }: StyleProps) {
  return items?.map(({ id, language }, _, { length }) => {
    const { flag, originalName } = LANGUAGES[language];
    const handleClick = () => onClick(language);

    return (
      <StyleLayout.Container
        key={id}
        itemsLength={length}
        languageCode={language}
        onClick={handleClick}
      >
        <StyleLayout.Flag
          icon={flag}
          style="squared"
          languageName={originalName}
        />
      </StyleLayout.Container>
    );
  });
}
